import { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

interface GuideAvatarProps {
  src?: string;
  alt?: string;
  className?: string;
}

const GuideAvatar: FC<GuideAvatarProps> = ({ src, alt = '', className = '' }) => {
  const [hasError, setHasError] = useState(false);
  const showImage = !!src && !hasError;

  return (
    <div className={`${className}${showImage ? '' : ' is-placeholder'}`.trim()}>
      {showImage ? (
        <img src={src} alt={alt} onError={() => setHasError(true)} />
      ) : (
        <FontAwesomeIcon icon={faUser as any} />
      )}
    </div>
  );
};

export default GuideAvatar;
